module.exports = __webpack_public_path__ + "static/media/yt-placeholder.6afec7ca.jpeg";